/**
 * The Velocity page's by-hour chart, loading its own data, for the Dashboard.
 * Science.co only, like the page: render it only when Science is selected.
 */

import { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

import { velocityAPI } from '../../services/api'
import { Button, Card, CardContent } from '../ui'
import { Notice } from '../scienceModel/parts'
import HourlyChart from './HourlyChart'
import { reachesFor } from '../../lib/velocity'

const REFRESH_MS = 5 * 60 * 1000

export default function VelocityHourlyCard() {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let alive = true
    const load = () => velocityAPI.get()
      .then(response => { if (alive && response.data.success) { setData(response.data.data); setError(null) } })
      .catch(err => { if (alive) setError(err.response?.data?.error?.message || err.message) })
    load()
    const timer = setInterval(load, REFRESH_MS)
    return () => { alive = false; clearInterval(timer) }
  }, [])

  const reaches = useMemo(() => reachesFor(data), [data])

  if (!data) {
    return (
      <Card>
        <CardContent className="p-4">
          {error
            ? <Notice tone="error">Velocity unavailable: {error}</Notice>
            : <div className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Loading velocity…</div>}
        </CardContent>
      </Card>
    )
  }

  return (
    <HourlyChart
      data={data}
      reaches={reaches}
      title="Velocity by hour"
      // Same button as the Last 7 days card's "Full report", top right.
      action={(
        <Button asChild variant="outline" size="sm" className="shrink-0">
          <Link to="/reports/velocity">Full velocity</Link>
        </Button>
      )}
    />
  )
}
